// src/app/no-cache.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Replicates the browser's "Disable cache" DevTools behavior for API calls:
 * every outgoing request carries no-cache headers so the browser and any
 * intermediate cache always revalidate with the backend.
 */
@Injectable()
export class NoCacheInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const noCacheRequest = request.clone({
      setHeaders: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      }
    });
    return next.handle(noCacheRequest);
  }
}
